import { api } from "@/Shared";
import { MatchingModel } from "./MatchingModel";
import { ApiResponse} from "@/OneLiners";

export class MatchingComputeService {


	static async fetchSinceDate(date: string): Promise<ApiResponse<MatchingModel[]>> {
		try {
			const { data } = await api.get<ApiResponse<MatchingModel[]>>(`/matchings/touch-since/${date}`);
			return data;
		} catch (error) {
			console.error(error);
			return { data: [] } as ApiResponse<MatchingModel[]>;
		}
	}

	static async computeMatchingsBy(type : 'need' | 'property', propertyId : number) : Promise<ApiResponse<null>>{
		try {
			const { data } = await api.post<ApiResponse<null>>(`/matchings/${type}/${propertyId}`);
			return data;
		} catch (error) {
			console.error(error);
			return { data: null } as ApiResponse<null>;
		}
	}

	/*
	static async refreshMatchingsByNeed(needId : number) : Promise<ApiResponse<null>>{
		try {
			const { data } = await api.post<ApiResponse<null>>(`/matchings/need/${needId}`);
			return data;
		} catch (error) {
			console.error(error);
			return { data: null } as ApiResponse<null>;
		}
	}*/
}